import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/account-favorite.svg")